import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import API from '../../utils/api';
import toast from 'react-hot-toast';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [recentBills, setRecentBills] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([API.get('/bills/stats/dashboard'), API.get('/bills')])
      .then(([s, b]) => {
        setStats(s.data);
        setRecentBills(b.data.slice(0, 5));
      })
      .catch(() => toast.error('Failed to load dashboard'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Layout title="Dashboard"><div style={{ padding: 40, textAlign: 'center', color: 'var(--gray-400)' }}>Loading dashboard...</div></Layout>;

  return (
    <Layout title="Dashboard Overview">
      <div className="stats-grid">
        {[
          { label: "Today's Revenue", value: `₹${(stats?.todayRevenue || 0).toFixed(0)}`, sub: `${stats?.todayBills || 0} bills today`, icon: '💰', cls: '' },
          { label: 'Total Revenue', value: `₹${(stats?.totalRevenue || 0).toFixed(0)}`, sub: `${stats?.totalBills || 0} total bills`, icon: '📈', cls: 'navy' },
          { label: 'Total Customers', value: stats?.totalCustomers || 0, sub: 'Registered customers', icon: '👥', cls: 'green' },
          { label: 'Pending Dues', value: `₹${(stats?.totalPendingAmount || 0).toFixed(0)}`, sub: `${stats?.pendingDues || 0} open accounts`, icon: '⏳', cls: 'amber' },
          { label: 'Products', value: stats?.totalProducts || 0, sub: `${stats?.lowStockProducts || 0} low stock`, icon: '📦', cls: stats?.lowStockProducts > 0 ? 'red' : 'green' },
        ].map(s => (
          <div key={s.label} className={`stat-card ${s.cls}`}>
            <div className="stat-label">{s.label}</div>
            <div className="stat-value">{s.value}</div>
            <div className="stat-sub">{s.sub}</div>
            <div className="stat-icon">{s.icon}</div>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">Recent Bills</span>
          <a href="/admin/bills" style={{ fontSize: '0.82rem', color: 'var(--navy)', textDecoration: 'none', fontWeight: 500 }}>View All →</a>
        </div>
        <div className="table-wrap">
          {recentBills.length === 0 ? (
            <div className="empty-state"><div className="empty-icon">🧾</div><div className="empty-title">No bills yet</div><div className="empty-text">Bills will appear here once created</div></div>
          ) : (
            <table>
              <thead><tr><th>Invoice No</th><th>Customer</th><th>Amount</th><th>Payment</th><th>Date</th><th>By</th></tr></thead>
              <tbody>
                {recentBills.map(b => (
                  <tr key={b.id}>
                    <td><strong style={{ color: 'var(--navy)' }}>{b.invoiceNo}</strong></td>
                    <td>{b.customer?.name || '—'}</td>
                    <td><strong style={{ fontFamily: 'var(--font-display)' }}>₹{b.total.toFixed(2)}</strong></td>
                    <td><span className={`badge ${b.paymentMode === 'cash' ? 'badge-green' : b.paymentMode === 'card' ? 'badge-navy' : b.paymentMode === 'credit' ? 'badge-red' : b.paymentMode === 'discount' ? 'badge-amber' : 'badge-amber'}`}>{b.paymentMode}</span></td>
                    <td>{new Date(b.createdAt).toLocaleDateString('en-IN')}</td>
                    <td>{b.employee?.name || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </Layout>
  );
}
